import React, { useState } from "react";
import "./Avatar.scss";

const Avatar = ({ size, image }) => {
  const [loaded, setLoaded] = useState(false);

  const handleLoad = () => {
    setTimeout(() => setLoaded(true), 50);
  };

  return (
    <div
      style={{ minWidth: size, maxWidth: size, height: size }}
      className="Avatar"
      data-loaded={loaded}
    >
      <div className="Loading">...</div>
      <div className="Image" style={{ backgroundImage: `url(${image})` }}>
        <img onLoad={() => handleLoad()} src={image} alt="" />
      </div>
    </div>
  );
};

export default Avatar;
